module.exports = __webpack_public_path__ + "resources/img/img_dvision8.c22afffba29646580e8c326fb10370da.png";